// components/Orders/OrderPanel.jsx
// ─────────────────────────────────────────────────────────────────────────────
// The white panel with a yellow accent and a small capitals title, and the
// label/value cell inside it: the two building blocks of the order screens
// drawn in components/Orders/orderDetailsTheme.css. Shared by the admin order
// page (OrderDetailsCard) and the ticket order page (TicketOrderDetails).
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";

/** One label/value cell of a facts grid. Renders nothing without a value, so
 *  the grid never shows a heading with an empty space under it. */
export const Fact = ({ label, value, wide }) => {
  const empty =
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0);
  if (empty) return null;
  return (
    <div className={`rod-fact ${wide ? "rod-fact-wide" : ""}`}>
      <span className="rod-fact-label">{label}</span>
      <span className="rod-fact-value">{value}</span>
    </div>
  );
};

export const Panel = ({ title, children, action, style }) => (
  <div className="rod-panel" style={style}>
    <div className="rod-panel-header">
      <span className="rod-panel-accent" />
      <h6 className="rod-panel-title">{title}</h6>
      {action && <div style={{ marginLeft: "auto" }}>{action}</div>}
    </div>
    <div className="rod-panel-body">{children}</div>
  </div>
);

export default Panel;
